import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { ActivatedRoute } from '@angular/router';
import { GoogleAnalyticsService } from '../../services/google-analytics.service';
/**
 * Activate device Component
 */
let ActivateDeviceComponent = class ActivateDeviceComponent {
    constructor(httpClient, route, googleAnalyticsService) {
        this.httpClient = httpClient;
        this.route = route;
        this.googleAnalyticsService = googleAnalyticsService;
        this.statusMessage = '';
        this.loginVisible = true;
    }
    ngOnInit() {
        this.route.params.subscribe((params) => {
            this.httpClient.get('user/activatedevice/' + params['hash']).subscribe((result) => {
                this.statusMessage = result['message'];
                if (result['userId']) {
                    let array = [];
                    array.push({
                        'event': 'deviceWhitelisted',
                        userId: result['userId']
                    });
                    this.googleAnalyticsService.pushGAEvents(array);
                    this.loginVisible = true;
                }
            }, (error) => {
                this.statusMessage = error.error['message'];
                this.loginVisible = false;
            });
        });
    }
};
ActivateDeviceComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: ActivatedRoute },
    { type: GoogleAnalyticsService }
];
ActivateDeviceComponent = __decorate([
    Component({
        selector: 'ecd-activate-device',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./activate-device.component.html")).default
    })
], ActivateDeviceComponent);
export { ActivateDeviceComponent };
